import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';
import { HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class Requerimientos3Service {
  private isAuthenticated = false;
  idEmpresa: string;
  idUsuario: string;
  infoUsuario: any;
  idInstituto: string;

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
      // // this.obtienInfo();
      // this.getIsAuth();
  }
//   getIsAuth(){
//     console.log("inicio sesion 1ro::", this.isAuthenticated);
// if (this.isAuthenticated) {
//   console.log('entro el if 1ro');
//   this.obtienInfo();
// }
//     return this.isAuthenticated;
//   }

  obtienInfo(){
    console.log("entro porque inicio sesion obtienInfo");

    this.idUsuario = this.authService.getIdUsuario();
    this.idInstituto = this.authService.getInstituto();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    // console.log(infoUsu);
    this.idEmpresa = infoUsu.empresaId;
    this.infoUsuario = this.authService.getInfoUsuario();
  }


  getInstituto(){

    this.obtienInfo();
    return this.idInstituto;
  }

  getInfoUsuario(){
    return this.infoUsuario;
  }

  getInfoReqTecUser(){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.reqTec.get + this.idEmpresa, null);
  }


  getBanderasRequerimientosTecnicos(empresaId,productoId){
   return this.http.get(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.getBanderaRequerimientoTecnicos+empresaId+'/'+productoId);
 }
  setBanderasRequerimientosTecnicos(empresaId,productoId,requerimientosv3){
   return this.http.post(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.setBanderaRequerimientoTecnicos+empresaId+'/'+productoId,requerimientosv3);
 }

 saveCuestionarioRequerimientosTecnicos(productoId,datos){
   return this.http.post(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.savePreguntas+productoId,datos);
 }

 // getCuestionarioRequerimientosTecnicos(productoId){
 //   return this.http.get(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.getCuestionarioRT+productoId);
 // }
 /////servicio que obtiene  todo el catalogo de preguntas
 getAllCatalogoCuestionarios(productoId){
   return this.http.get(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.getCatalogoPreguntasAll+productoId);

 }

 getBanderasRequerimientosTecnicosExternos(empresaId,productoId){
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.getBanderaRequerimientoTecnicosExterno+empresaId+'/'+productoId);
}
 setBanderasRequerimientosTecnicosExternos(empresaId,productoId,requerimientosv3){
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.setBanderaRequerimientoTecnicosExterno+empresaId+'/'+productoId,requerimientosv3);
}
 envioCorreosPruebas(empresaId,productoId,datos){
   return this.http.post(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.envioCorreoPrueba+empresaId+'/'+productoId,datos);

 }

//Envio de correos para portal externo
 envioCorreosPruebasExterno(empresaId,productoId,datos){
   return this.http.post(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.envioCorreoPruebaExterno+empresaId+'/'+productoId,datos);

 }
///servicio que trae preguntas por idioma
 getCatalogoPreguntasRequerimientos(productoId,clave){
   return this.http.get(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.getCatalogoPreguntas+productoId+'/'+clave);
 }

 ///servicio que trae la primera clave disponible para la encuesta
  getUserSurveyRequerimientosTecnicos(instituto,idProducto){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.getUserSurveyRequerimientosTecnicos+instituto+'/'+idProducto);
  }

  ///servicio que guarda y actualiza la clave que se copie de la encuesta
   saveUserSurveyRequerimientosTecnicos(empresaId, datos){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.saveUserSurveyRequerimientosTecnicos+empresaId, datos);
   }
   actualizaBanderaTestEmailServ(empresaId:any,productoId:any){
     let datos='';
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.actualizaBanderaTestEmail+empresaId+'/'+productoId, datos);
   }

   getBanderasDominiosServ(empresaId:any,productoId:any){
       return this.http.get(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.getBanderasDominios+empresaId+'/'+productoId);
   }

   updateBanderasDominiosServ(empresaId:any,datos:any){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.updateBanderasDominios+empresaId,datos);
   }

   getBanderasDominiosServExternal(empresaId:any,productoId:any){
       return this.http.get(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.getBanderasDominiosExternal+empresaId+'/'+productoId);
   }

   updateBanderasDominiosServExternal(empresaId:any,datos:any){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.updateBanderasDominiosExternal+empresaId,datos);
   }

   getFormTI(empresaId:any, productoId:any){
     return this.http.get(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.getFormTI + empresaId + '/' + productoId);
   }

   saveFormTI(datos:any){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.requerimientosTecnicosv3.saveFormTI, datos);
   }

   getInfoEmpresa(idEmpresa:any){
     return this.http.get(DATOS_API.url + DATOS_API.endpoints.getDataInfoEmpresaExt+idEmpresa);
   }
   sendEmailHelpRT(idEmpresa:any,datos:any){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.sendEmailHelpRT+idEmpresa,datos);
   }
   sendEmailHelpRTExtern(idEmpresa:any,datos:any){
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.sendEmailHelpRTExter+idEmpresa,datos);
   }



}
